import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';

const numberValue = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const useCurrentStockForPosSale = () => {
  const [sales, setSales] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [returnSales, setReturnSales] = useState([]);
  const [returnPurchase, setReturnPurchase] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const normalizedSearch = searchTerm.trim();

  useEffect(() => {
    fetch('https://servers.thakurgaonexpress.com/rupkotha/getsalesproducts').then((res) => res.json()).then((data) => setSales(Array.isArray(data) ? data : [])).catch(() => setSales([]));
  }, []);

  useEffect(() => {
    fetch('https://servers.thakurgaonexpress.com/rupkotha/getpurchaseproducts').then((res) => res.json()).then((data) => setPurchases(Array.isArray(data) ? data : [])).catch(() => setPurchases([]));
  }, []);

  useEffect(() => {
    fetch('https://servers.thakurgaonexpress.com/rupkotha/getreturnsalesproducts').then((res) => res.json()).then((data) => setReturnSales(Array.isArray(data) ? data : [])).catch(() => setReturnSales([]));
  }, []);

  useEffect(() => {
    fetch('https://servers.thakurgaonexpress.com/rupkotha/getreturnpurchaseproducts').then((res) => res.json()).then((data) => setReturnPurchase(Array.isArray(data) ? data : [])).catch(() => setReturnPurchase([]));
  }, []);

  const { data: products = [], isLoading } = useQuery(
    ['pos-sale-products', normalizedSearch],
    async () => {
      const response = await fetch(`https://servers.thakurgaonexpress.com/rupkotha/getproductsforstock?searchTerm=${encodeURIComponent(normalizedSearch)}`);
      if (!response.ok) throw new Error('Unable to search products.');
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    },
    { enabled: Boolean(normalizedSearch), keepPreviousData: true }
  );

  const totalFor = (records, code, field) => records.reduce((sum, record) => (
    String(record?.code || '') === String(code || '') ? sum + numberValue(record?.[field]) : sum
  ), 0);

  const stockData = products.map((product) => {
    const code = product?.code;
    const totalSale = totalFor(sales, code, 'quantity');
    const totalPurchase = totalFor(purchases, code, 'quantity');
    const totalReturn = totalFor(returnSales, code, 'returnQuantity');
    const totalPurchaseReturn = totalFor(returnPurchase, code, 'returnQuantity');
    const opening = numberValue(product?.opening);
    const stock = opening + totalPurchase + totalReturn - totalSale - totalPurchaseReturn;
    return {
      _id: product?._id,
      name: product?.name || 'Unnamed product',
      code: product?.code || '',
      category: product?.category,
      brand: product?.brand,
      minimum: product?.minimum,
      origin: product?.origin,
      unit: product?.unit,
      status: product?.status,
      purchase: numberValue(product?.purchase),
      sell: numberValue(product?.sell),
      opening,
      totalSale,
      totalPurchase,
      totalReturn,
      totalPurchaseReturn,
      stock,
      stockCost: stock * numberValue(product?.purchase),
    };
  });

  const lowercaseSearch = normalizedSearch.toLowerCase();
  const filtered = stockData.filter((product) => (
    product.stock > 0
    && (product.name.toLowerCase().includes(lowercaseSearch) || String(product.code).toLowerCase().includes(lowercaseSearch))
  ));

  return { filtered, stockData, isLoading, searchTerm, setSearchTerm, isSearching, setIsSearching };
};

export default useCurrentStockForPosSale;
